/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Query } from '../models/Query';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class QueriesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get a query
     * @param workspaceId
     * @param projectId
     * @param id
     * @returns any Successful request
     * @throws ApiError
     */
    public queriesGet(
        workspaceId: string,
        projectId: string,
        id: string,
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Query;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/queries/{workspaceId}/{projectId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'projectId': projectId,
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Update a query
     * @param workspaceId
     * @param projectId
     * @param id
     * @param requestBody The query properties to update
     * @returns any Successful request
     * @throws ApiError
     */
    public queriesPut(
        workspaceId: string,
        projectId: string,
        id: string,
        requestBody: {
            /**
             * Name of the query
             */
            name: string;
            /**
             * Description of the query
             */
            description: string;
            parameters: {
                /**
                 * Aggregates to compute when running the query
                 */
                calculations?: Array<{
                    key?: string;
                    operator: 'uniq' | 'count' | 'max' | 'min' | 'sum' | 'avg' | 'median' | 'p001' | 'p01' | 'p05' | 'p10' | 'p25' | 'p75' | 'p90' | 'p95' | 'p99' | 'p999' | 'stddev' | 'variance' | 'array_max_size' | 'array_min_size' | 'array_avg_size';
                    alias?: string;
                }>;
                /**
                 * How to group the query run results
                 */
                groupBys?: Array<{
                    type: 'string' | 'number' | 'boolean';
                    value: string;
                }>;
                /**
                 * How to order the results of the query
                 */
                orderBy?: {
                    value: string;
                    order?: 'asc' | 'desc';
                };
                /**
                 * The limit on the number of events / groups returned in the query results
                 */
                limit?: number;
                /**
                 * The filters to apply on the data when running the query
                 */
                filters?: Array<{
                    /**
                     * The filters to apply on the data in this group
                     */
                    filters?: Array<{
                        key: string;
                        operation: 'exists' | 'is_null' | 'starts_with' | 'regex' | 'includes' | 'not_includes' | 'in' | 'not_in' | 'array_size' | 'array_size_gt' | 'array_size_gte' | 'array_size_lt' | 'array_size_lte' | 'array_is_empty' | 'array_not_empty' | 'array_contains' | 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                        value?: (string | number | boolean);
                        type: 'string' | 'number' | 'boolean' | 'array';
                    }>;
                    /**
                     * How to combine the filters in this group
                     */
                    filterCombination?: 'and' | 'or';
                }>;
                /**
                 * How to combine the filters across groups
                 */
                filterCombination?: 'and' | 'or';
                /**
                 * Expression to search on the data when running the query
                 */
                needle?: {
                    value: (string | number | boolean);
                    isRegex?: boolean;
                    matchCase?: boolean;
                };
            };
            ownerId: string;
        },
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Query;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/queries/{workspaceId}/{projectId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'projectId': projectId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Update the fields of a query
     * @param workspaceId
     * @param projectId
     * @param id
     * @param requestBody The query properties to update
     * @returns any Successful request
     * @throws ApiError
     */
    public queriesPatch(
        workspaceId: string,
        projectId: string,
        id: string,
        requestBody: {
            /**
             * Name of the query
             */
            name?: string;
            /**
             * Description of the query
             */
            description?: string;
            parameters?: {
                /**
                 * Aggregates to compute when running the query
                 */
                calculations?: Array<{
                    key?: string;
                    operator: 'uniq' | 'count' | 'max' | 'min' | 'sum' | 'avg' | 'median' | 'p001' | 'p01' | 'p05' | 'p10' | 'p25' | 'p75' | 'p90' | 'p95' | 'p99' | 'p999' | 'stddev' | 'variance' | 'array_max_size' | 'array_min_size' | 'array_avg_size';
                    alias?: string;
                }>;
                /**
                 * How to group the query run results
                 */
                groupBys?: Array<{
                    type: 'string' | 'number' | 'boolean';
                    value: string;
                }>;
                /**
                 * How to order the results of the query
                 */
                orderBy?: {
                    value: string;
                    order?: 'asc' | 'desc';
                };
                /**
                 * The limit on the number of events / groups returned in the query results
                 */
                limit?: number;
                /**
                 * The filters to apply on the data when running the query
                 */
                filters?: Array<{
                    /**
                     * The filters to apply on the data in this group
                     */
                    filters?: Array<{
                        key: string;
                        operation: 'exists' | 'is_null' | 'starts_with' | 'regex' | 'includes' | 'not_includes' | 'in' | 'not_in' | 'array_size' | 'array_size_gt' | 'array_size_gte' | 'array_size_lt' | 'array_size_lte' | 'array_is_empty' | 'array_not_empty' | 'array_contains' | 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                        value?: (string | number | boolean);
                        type: 'string' | 'number' | 'boolean' | 'array';
                    }>;
                    /**
                     * How to combine the filters in this group
                     */
                    filterCombination?: 'and' | 'or';
                }>;
                /**
                 * How to combine the filters across groups
                 */
                filterCombination?: 'and' | 'or';
                /**
                 * Expression to search on the data when running the query
                 */
                needle?: {
                    value: (string | number | boolean);
                    isRegex?: boolean;
                    matchCase?: boolean;
                };
            };
            ownerId?: string;
        },
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Query;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/queries/{workspaceId}/{projectId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'projectId': projectId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Delete a query
     * @param workspaceId
     * @param projectId
     * @param id
     * @returns any Successful request
     * @throws ApiError
     */
    public queriesDel(
        workspaceId: string,
        projectId: string,
        id: string,
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: {
            /**
             * ID of the query
             */
            id: string;
            _object: 'query';
        };
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/queries/{workspaceId}/{projectId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'projectId': projectId,
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * List queries
     * @param workspaceId
     * @param projectId
     * @param orderBy
     * @param perPage
     * @param page
     * @param order
     * @param name
     * @param description
     * @param createdBy
     * @param ownerId
     * @param lastEditedBy
     * @returns any Successful request
     * @throws ApiError
     */
    public queriesList(
        workspaceId: string,
        projectId: string,
        orderBy: 'id' | 'name' | 'description' | 'createdBy' | 'ownerId' | 'lastEditedBy' | 'created' | 'updated' = 'created',
        perPage: string = '20',
        page: string = '1',
        order: 'asc' | 'desc' = 'desc',
        name?: (string | Array<string>),
        description?: (string | Array<string>),
        createdBy?: (string | Array<string>),
        ownerId?: (string | Array<string>),
        lastEditedBy?: (string | Array<string>),
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Array<Query>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/queries/{workspaceId}/{projectId}',
            path: {
                'workspaceId': workspaceId,
                'projectId': projectId,
            },
            query: {
                'orderBy': orderBy,
                'perPage': perPage,
                'page': page,
                'order': order,
                'name': name,
                'description': description,
                'createdBy': createdBy,
                'ownerId': ownerId,
                'lastEditedBy': lastEditedBy,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Create a new query
     * @param requestBody The query to create
     * @returns any Resource created
     * @throws ApiError
     */
    public queriesPost(
        requestBody: {
            /**
             * ID of the workspace
             */
            workspaceId: string;
            /**
             * ID of the project
             */
            projectId: string;
            /**
             * Name of the query
             */
            name: string;
            /**
             * Description of the query
             */
            description: string;
            parameters: {
                /**
                 * Aggregates to compute when running the query
                 */
                calculations?: Array<{
                    key?: string;
                    operator: 'uniq' | 'count' | 'max' | 'min' | 'sum' | 'avg' | 'median' | 'p001' | 'p01' | 'p05' | 'p10' | 'p25' | 'p75' | 'p90' | 'p95' | 'p99' | 'p999' | 'stddev' | 'variance' | 'array_max_size' | 'array_min_size' | 'array_avg_size';
                    alias?: string;
                }>;
                /**
                 * How to group the query run results
                 */
                groupBys?: Array<{
                    type: 'string' | 'number' | 'boolean';
                    value: string;
                }>;
                /**
                 * How to order the results of the query
                 */
                orderBy?: {
                    value: string;
                    order?: 'asc' | 'desc';
                };
                /**
                 * The limit on the number of events / groups returned in the query results
                 */
                limit?: number;
                /**
                 * The filters to apply on the data when running the query
                 */
                filters?: Array<{
                    /**
                     * The filters to apply on the data in this group
                     */
                    filters?: Array<{
                        key: string;
                        operation: 'exists' | 'is_null' | 'starts_with' | 'regex' | 'includes' | 'not_includes' | 'in' | 'not_in' | 'array_size' | 'array_size_gt' | 'array_size_gte' | 'array_size_lt' | 'array_size_lte' | 'array_is_empty' | 'array_not_empty' | 'array_contains' | 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                        value?: (string | number | boolean);
                        type: 'string' | 'number' | 'boolean' | 'array';
                    }>;
                    /**
                     * How to combine the filters in this group
                     */
                    filterCombination?: 'and' | 'or';
                }>;
                /**
                 * How to combine the filters across groups
                 */
                filterCombination?: 'and' | 'or';
                /**
                 * Expression to search on the data when running the query
                 */
                needle?: {
                    value: (string | number | boolean);
                    isRegex?: boolean;
                    matchCase?: boolean;
                };
            };
        },
    ): CancelablePromise<{
        message: {
            message: 'Resource created';
        };
        success: boolean;
        error: any;
        result: Query;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/queries/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
}
